import * as Yup from "yup";

import {
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@material-ui/core";
import { Field, Form, Formik } from "formik";
import React, { useState } from "react";

import CustomAlert from "../../components/CustomAlert";
import CustomDialog from "../../components/CustomDialog";
import { TextField as FormikTextField } from "formik-material-ui";
import { createShip } from "../../../services/shipService";
import useLocale from "../../../hooks/useLocale";
import { useMutation } from "react-query";

function CreateDialog({ open, close, refreshTable }) {
  const { t } = useLocale();
  const [error, setError] = useState("");

  // Mutation for creating data
  const { mutate } = useMutation(createShip, {
    onSuccess: (data) => {
      refreshTable();
      close();
    },
    onError: (error) => {
      switch (error) {
        default: {
          setError(t("A network error occured. Please try again later"));
        }
      }
    },
  });

  // Initial values
  const initialValues = {
    dds: "",
  };

  const sailorFormValidation = Yup.object().shape({
    dds: Yup.string().required("Field is required"),
  });

  const handleCreateItem = (values) => {
    mutate({ items: JSON.stringify([values]) });
  };

  return (
    <>
      <CustomDialog
        open={open}
        onClose={close}
        aria-labelledby="form-dialog-title"
        maxWidth="md"
      >
        <DialogTitle id="form-dialog-title">{t("Insert New Ship")}</DialogTitle>
        <CustomAlert
          open={!!error}
          close={() => {
            setError("");
          }}
          message={t("A network error occured, please try again later")}
        />
        <Formik
          initialValues={initialValues}
          validationSchema={sailorFormValidation}
          onSubmit={(values, { setSubmitting }) => {
            handleCreateItem(values);
            setSubmitting(false);
          }}
        >
          {({ submitForm }) => (
            <Form>
              <DialogContent>
                <Field
                  fullWidth
                  variant="outlined"
                  margin="normal"
                  name="dds"
                  type="text"
                  label={t("Call Sign")}
                  component={FormikTextField}
                />
              </DialogContent>
              <DialogActions>
                <Button onClick={submitForm} color="primary">
                  {t("Add")}
                </Button>
                <Button onClick={close} color="primary">
                  {t("Cancel")}
                </Button>
              </DialogActions>
            </Form>
          )}
        </Formik>
      </CustomDialog>
    </>
  );
}

export default CreateDialog;
